import Layout from './components/Layout/Layout.js'

function App() {
  return (
    <div className="App">
      <Layout/>
    </div>
  );
}

export default App;
